import { render, staticRenderFns } from "./CardDetails.vue?vue&type=template&id=5427b11c&scoped=true&"
import script from "./CardDetails.vue?vue&type=script&lang=js&"
export * from "./CardDetails.vue?vue&type=script&lang=js&"
import style0 from "./CardDetails.vue?vue&type=style&index=0&id=5427b11c&lang=scss&scoped=true&"
import style1 from "./CardDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5427b11c",
  null
  
)

export default component.exports